// Oesterreichische Mobilnummer-Validierung/Normalisierung.
// Zentral extrahiert aus src/app/account/Account.js, damit Account UND das
// Chat-Widget (Rueckruf-Flow) dieselbe Logik nutzen.

// RTR mobile ranges: (0)650-(0)653, (0)655, (0)657, (0)659-(0)661, (0)663-(0)699
const AT_MOBILE_PREFIXES = (() => {
  const excluded = new Set([654, 656, 658, 662]);
  const prefixes = [];
  for (let prefix = 650; prefix <= 699; prefix += 1) {
    if (!excluded.has(prefix)) prefixes.push(String(prefix));
  }
  return new Set(prefixes);
})();

const STRIP_PHONE_SEPARATORS_REGEX = /[\s\-()/.]/g;
const ALLOWED_PHONE_CHARS_REGEX = /^[\d\s()+\-/.]+$/;

// Gibt { e164: "+43..." } zurueck oder null, wenn keine gueltige AT-Mobilnummer.
export function normalizeAustrianMobilePhone(raw) {
  if (typeof raw !== "string") return null;
  if (!ALLOWED_PHONE_CHARS_REGEX.test(raw)) return null;

  const compact = raw.replace(STRIP_PHONE_SEPARATORS_REGEX, "");
  if (!compact) return null;

  const plusCount = (compact.match(/\+/g) || []).length;
  if (plusCount > 1) return null;
  if (compact.includes("+") && !compact.startsWith("+")) return null;

  let nationalMobilePart = "";
  if (compact.startsWith("+43")) {
    nationalMobilePart = compact.slice(3);
  } else if (compact.startsWith("0043")) {
    nationalMobilePart = compact.slice(4);
  } else if (compact.startsWith("0")) {
    nationalMobilePart = compact.slice(1);
  } else {
    return null;
  }

  if (!/^\d+$/.test(nationalMobilePart)) return null;
  if (nationalMobilePart.length < 10 || nationalMobilePart.length > 12) {
    return null;
  }

  const prefix = nationalMobilePart.slice(0, 3);
  const subscriber = nationalMobilePart.slice(3);
  if (!AT_MOBILE_PREFIXES.has(prefix)) return null;
  if (subscriber.length < 7 || subscriber.length > 9) return null;

  return {
    e164: `+43${nationalMobilePart}`,
  };
}
